import type { FC } from "react";

import { CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";

import type { CardsElementProps } from "../types";

export const CustomPageTitle: FC<CardsElementProps> = ({
  children,
  classes,
}) => {
  return (
    <CardTitle
      className={cn(
        "flex items-center gap-x-4 text-start font-[Almarai] text-2xl md:text-3xl font-extrabold lg:text-center tracking-normal",
        classes
      )}
    >
      {children}
    </CardTitle>
  );
};
